import { schema } from 'normalizr';

export const DISPLAY_PASSWORD_BANNER_STATE = 'password_banner';

export const passwordBannerDisplayStateSchema = new schema.Entity(
  DISPLAY_PASSWORD_BANNER_STATE,
  {},
  { idAttribute: () => 'data' }
);
